import { Navigate } from "react-router-dom";
import { useAuth } from "../api/auth/useAuth";
import { LoadingSpinner } from "./LoadingSpinner";

type RoleRouteProps = {
  children: React.ReactNode;
  /** Role names allowed through, e.g. ["super-admin", "admin"]. */
  roles: string[];
};

export const RoleRoute = ({ children, roles }: RoleRouteProps) => {
  const { user, isRestored } = useAuth();

  if (!isRestored) return <LoadingSpinner />;
  if (!user) return <Navigate to="/" replace />;

  // A user restored from localStorage may predate role details, so don't
  // trust the type here: no role name means no access.
  const roleName: string | undefined = user.role?.name;
  if (!roleName || !roles.includes(roleName)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};
